import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { AdditionalService } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/additional-services.model';
import * as fromAdditionalServicesAction from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/actions/additional-services.action';
import {
  OrderBuilderActions,
  RESET_BUILDER,
} from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface State extends EntityState<AdditionalService> {
  selectedAdditionalServiceId: number | null;
}

export const adapter: EntityAdapter<AdditionalService> = createEntityAdapter<AdditionalService>({
  selectId: ($additionalService: AdditionalService) => $additionalService.commercialCode,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedAdditionalServiceId: null,
});

export function reducer(
  state = initialState,
  action: fromAdditionalServicesAction.Actions | OrderBuilderActions,
): State {
  switch (action.type) {
    case fromAdditionalServicesAction.ActionTypes.ADD_ADDITIONAL_SERVICE: {
      return adapter.addMany(action.payload.additionalServices, { ...state });
    }
    case RESET_BUILDER:
    case fromAdditionalServicesAction.ActionTypes.CLEAR_ADDITIONAL_SERVICE: {
      return adapter.removeAll(state);
    }
    case fromAdditionalServicesAction.ActionTypes.NO_ACTION:
    default: {
      return state;
    }
  }
}

export const getEntities = (state: State) => state.entities;

export const getAdditionalServices = (state: State) => {
  const AdditionalServices: AdditionalService[] = Object.keys(state.entities).map(i => state.entities[i]);
  return AdditionalServices;
};
